@if (documents$ | async; as documents) {
<form (ngSubmit)="onDocumentClick( $event )">
  <dl class="items">
    @for (document of documents.documents; track document.name) {
    <div class="item">
      <dt class="item-value">
        <button
          type="submit"
          class="oneok-button oneok-blue"
          [attr.data-name]="document.name"
          [attr.data-url]="document.url"
          [attr.data-tooltip]="document.context"
        >
          <span>{{ document.name }}</span>
          <svg-icon src="/assets/svg/download.svg" />
        </button>
      </dt>
    </div>
    }
  </dl>
</form>
} @if (isExtraContent) {
<section class="details">
  <p>{{ documentsSource.value.title || "" }}</p>
  <div [innerHtml]="documentsSource.value.description || '' | safeHtml"></div>
</section>
}
